<script>
export default {
    props: {
        pagination: {
            type: [Object, Array],
            required: true,
        },

            offset: {
                type: Number,
                default: 5,
            },
            enablechange: {
                type: Boolean,
                default: false,
            },
    },

    data() {
        return {
            selectedPage: 1,
            perPage: 15,
            enteredPage: "",
        };
    },

    watch: {
        'pagination.current_page'(newVal) {
            console.log('🔍 Pagination watcher - current_page changed to:', newVal);
            this.selectedPage = newVal;
        },
        'pagination': {
            handler(newPagination) {
                console.log('🔍 Pagination watcher - pagination object changed:', newPagination);
                if (newPagination && newPagination.current_page) {
                    this.selectedPage = newPagination.current_page;
                }
            },
            deep: true,
            immediate: true
        }
    },
    methods: {
        isCurrentPage(page) {
            return this.pagination.current_page === page;
        },

        changePage(page, perPage = this.perPage) {
            console.log('🔍 changePage called with page:', page, 'perPage:', perPage);
            this.selectedPage = page
            if (page > this.pagination.last_page) {
                page = this.pagination.last_page;
            }
            //this.pagination.current_page = page;
            console.log('🔍 Emitting paginate with page:', page, 'perPage:', perPage);
            this.$emit("paginate", page, perPage);

            window.scrollTo(0, 0);
        },

        getPage() {
            if (
                _.isEmpty(this.enteredPage) ||
                this.enteredPage <= 0 ||
                this.enteredPage > this.pagination.last_page
            ) {
                return false;
            }

            this.changePage(this.enteredPage);
        },
    },

    computed: {
        pages() {
            let pages = [];
            let from =
                this.pagination.current_page - Math.floor(this.offset / 2);
            if (from < 1) {
                from = 1;
            }
            let to = from + this.offset - 1;
            if (to > this.pagination.last_page) {
                to = this.pagination.last_page;
            }
            while (from <= to) {
                pages.push(from);
                from++;
            }
            return pages;
        }, allPages() {
            const pages = [];
            for (let i = 1; i <= this.pagination.last_page; i++) {
                pages.push(i);
            }
            return pages;
        },
    },
};
</script>

<template>
    <nav aria-label="Page navigation" class="d-flex justify-content-center text-center customPaging mb-4">
        <!-- <div class="d-flex justify-content-center mb-3">
            <input class="bg-white form-control col-1 form-control-sm" type="number" v-model="enteredPage"
                @keyup="getPage" @change="getPage" placeholder="Goto Page" />
        </div> -->

        <select v-if="pagination.total && enablechange" class="pagination-select mx-2" v-model="perPage"
            @change="changePage(selectedPage, perPage)">
            <option value="" disabled>Num of Rows</option>
            <option :value="15">15</option>
            <option :value="25">25</option>
            <option :value="33">33</option>
        </select>

        <select v-if="pagination.last_page > 1" class="pagination-select" v-model="selectedPage"
            @change="changePage(selectedPage)">
            <option value="" disabled>Go to page</option>
            <option v-for="page in allPages" :key="page" :value="page">
                {{ page }}
            </option>
        </select>

        <ul class="pagination justify-content-center px-0 mb-0">
            <!-- <li class="page-item">
                <button
                    type="button"
                    class="page-link"
                    aria-label="Previous"
                    @click="changePage(1)"
                >
                    <font-awesome-icon icon="fa-solid fa-angle-double-left"/>
                </button>
            </li> -->

            <li class="page-item">
                <button type="button" class="page-link" aria-label="Previous"
                    @click="changePage(pagination.current_page - 1)" :disabled="pagination.current_page <= 1">
                    <!-- <span aria-hidden="true">&laquo;</span> -->
                    <font-awesome-icon icon="fa-solid fa-angle-left" />
                </button>
            </li>

            <li class="page-item" v-for="page in pages" :key="page" :class="{ active: isCurrentPage(page) }">
                <button class="page-link" @click="changePage(page)">
                    {{ page }}
                </button>
            </li>

            <li class="page-item">
                <button class="page-link" aria-label="Next" @click="changePage(pagination.current_page + 1)"
                    :disabled="pagination.current_page >= pagination.last_page">
                    <!-- <span aria-hidden="true">&raquo;</span> -->
                    <font-awesome-icon icon="fa-solid fa-angle-right" />
                </button>
            </li>

            <!-- <li class="page-item">
                <button
                    class="page-link"
                    aria-label="Next"
                    @click="changePage(pagination.last_page)"
                >
                    <font-awesome-icon icon="fa-solid fa-angle-double-right"/>
                </button>
            </li> -->
        </ul>
        <div class="text-center countResult" v-if="pagination.total">
            <small v-html="$t('messages.pagination_message', {
                total: pagination.total,
                from: pagination.from,
                to: pagination.to,
            })
                "></small>
        </div>
    </nav>
</template>

<style scoped>
nav {
    background-color: transparent !important;
    box-shadow: none !important;
    color: #000 !important;
}

button:disabled {
    cursor: not-allowed;
}
</style>
